'use strict'

import store from 'src/vuex/store.js'

import ConfigStoreClass from './js/ConfigStoreClass.js'

const getConfigModel = import('./Config.js')
  .then(m => m.Configs)

class ConfigStore extends ConfigStoreClass {

  static getConfigModelPromise () {
    return getConfigModel
  }

  static getRegisterModuleName () {
    return 'Config'
  }
}

// eslint-disable-next-line no-unused-vars
const config = new ConfigStore()

export default store
